module.exports = __webpack_public_path__ + "img/cusetomerImg3.9e18e801.png";